export const ja = {
  report: {
    Unedited: '未編集',
    Editing: '編集',
    Finalized: '完成',
    exam_info: '検査詳細',
    findings: '所見',
    diagnosis: '診断',
    suggestion: 'アドバイス',
    summary: 'サマリー',
    auto_generate: '自動生成文',
    generating_descriptive_paragraph: '記述的段落を生成中...',
    confirm: {
      title: '削除',
      text: '所見（{0}）を削除してよろしいですか？',
      delete_image: '本当に削除してよろしいですか',
    },
    reset_timer: 'タイマーをリセット',
    simple: 'ダイジェスト版',
    normal: '詳細版',
    image_not_show_on_print: 'レポートに表示しない',
    select_landmarks: '選択',
    english_report: 'レポート',
    cleansing_comment1: '検査中、医師は大腸内の残留物を洗い流しました。クレンジングレベルが',
    cleansing_comment2: 'から',
    cleansing_comment3: 'に変更されました.洗浄が不十分であった部分はすべて洗浄されましたので、ご安心ください。',
    quality_report: '品質レポート',
  },
  report_preview: {
    title: 'レポートプレビュー',
    ai: 'AIスマート医療レポート',
    back_to: '編集に戻る',
    Gastroscopy: '上部消化管内視鏡報告',
    Colonoscopy: '大腸内視鏡レポート',
    name: '@:patient.name',
    gender: '性別',
    age: '@:patient.age',
    recordNo: '患者番号',
    examDate: '@:examination.date',
    examTime: '検査時間',
    examItem: '検査種別',
    GastroscopyCheckNo: '28016C',
    ColonoscopyCheckNo: '28017C',
    findings: '@:report.findings',
    report_date: '作成日',
    technician: '技師',
    print: '印刷',
    explanation: '結果説明',
    personal_info: '患者基本情報',
    diff: '検查前後対比',
    cleanse_off: '已清理乾淨，請您放心！ ',
    deepest: '検查最深処位置',
    timer: {
      title: '内視鏡抜去時間',
      withdrawal: '抜去時間',
      proximal: '近端大腸退出時間',
    },
    notice1: 'この検査には大腸の最深部位の画像がありません。表示したい場合は、医師に大腸の最深部を患者画像でマークしてもらってください。',
    notice2_start: '内視鏡は最深部で',
    notice2_end1: 'に到達し、大腸は完全に検査され、見逃し部位はありませんので、ご安心ください。',
    notice2_end2: 'に到達したため、',
    reason_describ: '原因の説明',
    describ: '原因',
    insertion_level: '到達部位',
    insertion_length: '最深部到達時スコープ長',
  },
  organization: {
    title: '施設',
    number: '施設コード',
    name: '氏名',
    phone: '電話番号',
    email: 'Email',
    connection: 'PACS連携',
    ae_title: 'Called_AE ',
    called_ip: 'Called_IP',
    called_port: 'Called_PORT',
    calling_ae: 'Calling_AE ',
    modality: 'モダリティ',
    record: 'リアルタイム音声機能',
  },
  doctor: {
    title: '医師',
    list: '医師一覧',
    new_doctor_added: '新規医師を追加しました',
    new_doctor: '新規医師',
  },
  examination: {
    list: '検査一覧',
    title: '検査',
    number: '患者ID',
    patient: '@:patient.name',
    date: '検査日',
    doctor: '検査医師名',
    type: '検査種別',
    add: '新しい検査を追加',
  },
  inspection_instrument: {
    title: '検査機器',
    list: '検査機器一覧',
    added: '新規検査機器を追加しました',
    new: '新規検査機器',
    edit: '編集'
  },
  wash_Instrument: {
    title: '洗浄機',
    list: '洗浄機一覧', 
    added: '新規洗浄機を追加しました',
    new: '新規洗浄機',
  },
  patient: {
    title: '患者',
    name: '患者氏名',
    id: '患者ID',
    dob: '生年月日',
    sex: '性別',
    age: '年齢',
    list: '患者一覧',
    medical_record: '患者ID',
    choose: '選択',
    birthday: '生年月日',
    add: '患者を追加',
    nation_id: '国籍ID',
  },
  nurse: {
    title: '技師・看護師',
    list: '技師・看護師一覧',
    added: '新規技師・看護師を追加しました',
    new_technical_staff: '新規技師・看護師',
  },
  user: {
    title: 'ユーザー',
    list: 'ユーザー一覧',
    username: 'ユーザー名',
    employee_type: '職種',
    doctor: '医師',
    employee: 'スタッフ',
    technical_staff: '技師',
    edit_pasword: 'パスワード編集',
    voice_repeat: '音声復唱機能',
    add_user: 'ユーザーを追加',
    min_8_character: '8文字以上で入力してください',
    atleat_8_character: '8文字以上で入力してください',
  },
  analytics: {
    title: '分析',
    search: '検索',
    filter: 'フィルター',
    fields_to_display: '表示項目',
    apply: '適用',
    no_data_available: '該当データなし',
    field: '項目',
    value: '値',
    polyp_detection_rate: 'ポリープ検出率',
    polyp_detection_rate_comparison: 'ポリプ検出率比較',
    time_interval: '検索期間',
    add_comparison: '追加',
    generate: '比較',
    ratio_of_withdrawal_time_6_min:'',
  },
  enviroment_test: {
    title: 'テスト環境',
    pedal: 'ペダル',
    camera: 'カメラ',
    microphone: 'マイク',
    pedaling: '踏み続けて下さい',
    single_pedal: 'ペダルを1回踏んでください',
    continuous_pedal: 'ペダルを踏み続けて下さい',
    allow_camera: 'カメラをオンにしてください',
    use_camera: '使用camera',
    use_microphone: '使用マイク',
    capture_pedal: 'ペダルでスクリーンショット',
    allow_microphone: 'マイクをオンにしてください',
    capture_pedal_audio: 'ペダルで録音します',
  },
  common: {
    name: '氏名',
    yes: 'はい',
    no: "いいえ",
    cancel: 'キャンセル',
    close: '閉じる',
    nil: "なし",
    summary: '概要',
    search: '検索',
    choose: '選択',
    reset: 'リセット',
    add: '追加',
    other: 'その他',
    other_image: 'その他画像',
    day: '日',
    loading: '読み込み中',
    gender: '性別',
    field: '項目',
    value: '値',
    excellent: '優良',
    good: '良好',
    fair: '中等',
    poor: '不良',
    male: '男',
    female: '女',
    add_new_finding: '所見を追加',
    ESOPHAGUS: '食道',
    STOMACH: '胃',
    DUODENUM: '十二指腸',
    NONSPECIFIC: '特になし',
    indication: '検査目的',
    insertion_time: '挿入時間',
    proximal_colon_withdrawal_time: '盲腸から脾弯曲部の抜去時間',
    withdraw_time: '抜去時間',
    total_exam: '総検査時間',
    preparation_agent: '前処置薬剤',
    preparation_time: '前処置所要時間',
    anti_platelet: '抗血栓藥',
    anti_platelet_stop: '休薬期間',
    send_report_to_email: '生成式レポートを送信',
    send_email: '送信',
    cleanse_level: {
      before: '腸管洗浄度（検査前）',
      after: '腸管洗浄度（検査後）',
    },
    scope_id: 'スコープID',
    sedatives: '鎮痛剤・鎮静剤',
    start_date: 'From（期間を指定）',
    end_date: 'To（期間を指定）',
    washing_machine: '洗浄機',
    premedication: {
      title: '前投薬',
      '1': '緑内障',
      '2': '前立腺肥大症',
      '3': '心疾患・不整脈',
      '4': '薬物アレルギー',
    },
    antispasmodics: {
      on: '抗てんかん薬を使用',
      off: '抗てんかん薬を使用せず',
    },
    insertion_level: '到達部位',
    insertion_length: '挿入長',
    complication: '合併症',
    clo_test: '迅速ウレアーゼテスト',
    additional_remarks: '備考',
    incomplete: {
      title: '検査中断理由',
      gastro: {
        '0': '',
        '1': '患者の苦痛',
        '2': '出血',
        '3': '食物残渣',
        '4': '未消化薬剤',
      },
      colon: {
        '0': '',
        '1': 'Poor Preparation',
        '2': '出血',
        '3': 'Bowel Perforation',
        '4': 'Patient Intolerance',
        '5': 'その他',
        '6': '食物残渣',
        '7': 'Undigested Medicine',
      }
    },
    procedure_note: '検査結果説明',
    required: '必須項目',
    not_specific: '未選択',
    microphone: 'マイク',
    camera: 'カメラ',
  },
  right_sidebar: {
    insertion_time: '挿入時間',
    proximal_colon_withdrawal_time: '盲腸から脾弯曲部の抜去時間',
    withdraw_time: '抜去時間',
    total_exam: '総検査時間',
    cleansing_level: 'Cleansing Level',
    complications: '合併症',
    clo_test: "CLOテスト",
    location: "部位",
    pylorus: "幽門",
    antrum: "前庭部",
    lowbody: "体下部",
    record: "録音",
  },
  dialog: {
    warn: '確認',
  },
  login:{
    username: "ユーザーID",
    password: "パスワード",  // NOSONAR
    verificationcode: "認証コード",
    signin: "ログイン"
  },
  homepage:{
    from: "From（期間を指定）",
    to: "To（期間を指定）",
    examination_records: "検査No.",
    medical_records: "患者ID",
    search: "検索",
    today: "本日",
    sync_worklist: "リストを同期",
    examinations: "検査",
    date: "検査日",
    examination_record: "検査No.",
    examination_type: "検査種別",
    patient_name: "患者氏名",
    medical_record: "患者ID",
    status: "ステータス",
    no_data_available: "データなし",
    rows_per_page: "行数を変更",
    singout: "ログアウト",
    select_examination: "左から選択すると詳細が表示されます",
    finished: "検査完了",
    unfinished: "検査待ち",
    colonoscopy: "下部消化管内視鏡",
    gastroscopy: "上部消化管内視鏡",
    sigmoidoscopy: "S状結腸内視鏡",
    gast:{
      birth: "生年月日",
      age: "@:patient.age",
      gender: "性別",
      male: "男性",
      female: "女性",
      scope_id: "スコープID",
      washing_machine: "洗浄機",
      doctor: "医師",
      nurse: "看護師",
      go_to_report: "レポートへ",
      start_examination: "検査を開始",
    },
    colon:{
      premedication: "@:common.premedication.title",
      preparation_agent: "前処置薬剤",
      preparationTime: "前処置所要時間",
      antiplatelet: "抗血栓薬",
      complication: "@:common.complication",
      without_medication: "休薬期間",
      please_select: "選択",
    }
  },

  poweredByFirst: 'Powered By',
  poweredBySecond: 'KENKONE EVAS',
  from: 'From',
  ward: 'Ward',
  applicationDate: 'Application Date',
  applicationTime: 'Application Time',
  applicationDr: 'Application DR',
  reportTime: 'Report Time',
  vs: 'VS.',
  examDr: 'EXAM. DR.',

  // ColonCloeanseForm
  informedConsent: 'Informed consent',
  insertionTime: 'Insertion Time',
  withdrawTime: '抜去時間',
  totalExamTime: 'Total Exam',
  proximalColonWithTime: 'Proximal Colon Withdrawal Time',

  // Colon finding
  finding: '所見',
  lesion: 'Lesion',
  procedureImages: 'Procedure Images',
  additionalImage: 'Additional Image',

  http: {
    error: {
      400: 'Bad Request',
      401: 'Unauthorized',
      403: 'Forbidden',
      404: 'Not Found',
      405: 'Method Not Allowed',
      406: 'Not Acceptable',
      408: 'Request Timeout',
      500: 'Internal Server Error',
      502: 'Bad Gateway',
      503: 'Service Unavailable',
      504: 'Gateway Timeout',
      505: 'HTTP Version Not Supported',
      999: 'JavaScript Error',
    },
  },
  i18n: {
    zh: '繁体中文',
    ja: '日本語',
    en: 'English',
  },
  finding_words:{
    "2nd_portion": "下行部",
    "abscess": "膿瘍",
    "acetic_acid": "酢酸",
    "active_bleeding": "活動性出血",
    "active": "活動性",
    "acute_gastritis": "急性胃炎",
    "adenomatous_polyp": "腺腫性ポリープ",
    "advanced": "進行",
    "advanced_cancer": "進行癌",
    "advanced_colorectal_cancer": "進行大腸癌",
    "all_segments_of_colon": "全結腸",
    "alligator": "鰐口鉗子",
    "amoeba": "アメーバ",
    "amoebic_colitis": "アメーバ性大腸炎",
    "amyloidosis": "アミロイドーシス",
    "anal_retroflex": "肛門部反転",
    "anastomosis": "吻合部",
    "angiodysplasia": "血管異形成",
    "angle": "角部",
    "antrum": "前庭部",
    "anus": "肛門",
    "appendiceal_tumor": "虫垂腫瘍",
    "appendix_orifice": "虫垂開口部",
    "ascending_colon": "上行結腸",
    "atrophic_gastritis": "萎縮性胃炎",
    "aw": "前壁",
    "band_ligation": "バンド結紮術",
    "barretts_esophagus": "バレット食道",
    "bechets_disease": "ベーチェット病",
    "bezoar": "胃石",
    "bezoar_removal": "胃石除去術",
    "biopsy": "生検",
    "biopsy_and_removal": "生検および除去",
    "biopsy_forceps": "生検鉗子",
    "biospy_forceps": "生検鉗子",
    "bleeding": "出血",
    "bleeding_continue": "出血持続",
    "bleeding_stop": "止血",
    "bleeding_tendency": "出血傾向",
    "blood_oozing": "滲出性出血",
    "body": "体部",
    "broad": "広域",
    "brunners_gland_hyperplasia": "ブルンネル腺過形成",
    "bulb": "球部",
    "bulbitis": "十二指腸炎",
    "cancer": "癌",
    "cap": "キャップ",
    "carcinoid_tumor": "カルチノイド腫瘍",
    "cardia": "噴門",
    "causes": "原因",
    "cecum": "盲腸",
    "cervical": "頸部",
    "cherry-red_spot": "チェリーレッドスポット",
    "chromag": "色素拡大観察",
    "chronic_esophagitis": "慢性食道炎",
    "chronic_gastritis": "慢性胃炎",
    "chromo_sign": "染色所見",
    "closed": "閉鎖",
    "cm": "cm",
    "distance_cm": "cm",
    "size_cm": "mm",
    "coagrasper": "コアグラスパー",
    "cold_biopsy": "コールドバイオプシー",
    "cold_snare": "コールドスネア",
    "colitis": "大腸炎",
    "colitis_aphthosa": "アフタ性大腸炎",
    "colon_fistula": "結腸瘻",
    "colon_maltoma": "大腸MALTリンパ腫",
    "colon_polyposis": "大腸ポリポーシス",
    "colon_polyposis,familiar": "家族性大腸ポリポーシス",
    "colonic_stricture": "大腸狭窄",
    "colonic_tuberculosis": "大腸結核",
    "colonic_wall_cyst": "結腸壁嚢胞",
    "color": "色調",
    "complete_obstruction": "完全閉塞",
    "completely_removed": "完全切除",
    "confluent": "癒合性",
    "congenital": "先天性",
    "consult_surgeon": "外科コンサルト",
    "consur": "外科コンサルト",
    "continuous-lesion": "連続性病変",
    "crohns_disease": "クローン病",
    "cytomegalovirus_colitis": "サイトメガロウイルス腸炎",
    "demarcation_line": "demarcation line",
    "description": "所見",
    "descending_colon": "下行結腸",
    "device": "デバイス",
    "diffuse_redness": "びまん性発赤",
    "diluted_epinephrine": "希釈エピネフリン",
    "distance": "距離",
    "distal": "遠位",
    "diverticula": "憩室",
    "diverticular_bleeding": "憩室出血",
    "diverticulitis": "憩室炎",
    "diverticulosis": "憩室症",
    "diverticulum": "憩室",
    "drug_induce_colitis": "薬剤誘発性大腸炎",
    "du": "十二指腸潰瘍",
    "dualknife": "デュアルナイフ",
    "dysplasia": "異形成",
    "each": "個別",
    "early": "早期",
    "early_cancer": "早期癌",
    "early_colorectal_cancer": "早期大腸癌",
    "early_or_advanced": "進行度",
    "easy_bleeding": "易出血性",
    "ecj": "食道胃接合部",
    "edema": "浮腫",
    "elastic": "弾性",
    "elective": "予防的",
    "emergent": "緊急",
    "en_bloc": "一括切除",
    "endolifter": "エンドリフター",
    "endoloop": "エンドループ",
    "erosion": "びらん",
    "erosions": "びらん",
    "erythema": "発赤調",
    "esophageal_ca": "食道癌",
    "esophageal_dysplasia": "食道異形成",
    "esophageal_stenosis": "食道狭窄",
    "esophageal_varices": "食道静脈瘤",
    "esophagus": "食道",
    "external": "外痔核",
    "external_hemorrhoid": "外痔核",
    "extraluminal_impression": "壁外圧排",
    "exudate": "滲出液",
    "fap": "家族性大腸腺腫症",
    "flat_erosion": "平坦びらん",
    "flat_tumor": "平坦型腫瘍",
    "flexknife": "フレックスナイフ",
    "focal": "巣状",
    "food_stasis": "食物停滞",
    "foreign_body": "異物",
    "form": "形狀",
    "fresh_blood": "鮮血",
    "friability": "易出血性",
    "fundic_gland_polyp": "胃底腺ポリープ",
    "fundus": "胃底部",
    "gastric_ca": "胃癌",
    "gastric_dysplasia": "胃異形成",
    "gastric_fold_hypertrophy": "胃粘膜ひだ腫大",
    "gastric_mucosa_atrophy": "胃粘膜萎縮",
    "gastric_varices": "胃静脈瘤",
    "gastritis": "胃炎",
    "gc": "大彎",
    "gerd": "胃食道逆流症",
    "gi_bleeding": "消化管出血",
    "giant": "巨大な",
    "gist": "GIST(消化管間質腫瘍)",
    "glycerol": "グリセリン",
    "grade": "グレード",
    "grasping_forceps": "把持鉗子",
    "gu": "胃潰瘍",
    "gvhd_related_colitis": "移植片対宿主病（GVHD）関連大腸炎",
    "hard": "硬",
    "healing": "治癒期",
    "heater_probe": "ヒータープローブ",
    "hemangioma": "血管腫",
    "hematin": "ヘマチン",
    "hemoclip": "クリップ",
    "hemorrhagic_colitis": "出血性大腸炎",
    "hemorrhagic_gastritis": "出血性胃炎",
    "hemorrhoid": "痔核",
    "hemostasis": "止血",
    "hepatic_flexure": "肝彎曲",
    "hiatal_hernia": "食道裂孔ヘルニア",
    "high-body": "体上部",
    "histoacryl": "ヒストアクリル",
    "hookknife": "フックナイフ",
    "hot_biopsy": "ホットバイオプシー",
    "hot_snare": "ホットスネア",
    "hyaluronic_acid": "ヒアルロン酸",
    "hybrid_knife": "ハイブリッドナイフ",
    "hyperplastic_polyp": "過形成性ポリープ",
    "ibd": "炎症性腸疾患",
    "I-sp": "0-Isp",
    "iia+c": "0-Ⅱa＋Ⅱc",
    "iic+a": "0-Ⅱc＋Ⅱa",
    "ileitis": "回腸炎",
    "ileocecal_valve": "回盲弁",
    "indigo_carmine": "インジゴカルミン",
    "infectious_colitis": "感染性腸炎",
    "inflammation": "炎症",
    "inflammatory_polyp": "炎症性ポリープ",
    "infrared_coagulation": "赤外線凝固術",
    "injection": "局注",
    "internal": "内痔核",
    "internal_hemorrhoid": "内痔核",
    "intervention": "処置",
    "intestinal_metaplasia": "腸上皮化生",
    "intramural_bleeding_spots": "壁内出血斑",
    "intraoperative_condition": "手術中",
    "intussusception": "腸重積",
    "ischemia": "虚血",
    "ischemic_colitis": "虚血性大腸炎",
    "itknife": "ITナイフ",
    "itknife_nano": "ITナイフナノ",
    "itknife-2": "ITナイフ2",
    "juvenile_polyp": "若年性ポリープ",
    "kudo": "Pit パターン",
    "l.a_grade": "ロサンゼルス分類",
    "lateral_spreading_tumor": "側方発育型腫瘍",
    "lc": "小弯",
    "left_hemicolectomy": "左半結腸切除術",
    "lipiodol": "リピオドール",
    "lipoma": "脂肪腫",
    "location": "部位",
    "low-body": "体下部",
    "lower": "下部",
    "lower_gi": "下部消化管",
    "lower_gi_bleeding": "下部消化管出血",
    "lugol-voiding": "ルゴール不染",
    "lugols_solution": "ルゴール液",
    "lymphangioma": "リンパ管腫",
    "lymphoid_follicles": "リンパ濾胞",
    "lymphoid_hyperplasia": "リンパ濾胞過形成",
    "lymphoma": "リンパ腫",
    "magnification": "拡大観察",
    "major_bleeding": "大量出血",
    "malignancy": "悪性腫瘍",
    "maneuver": "操作",
    "mega_colon": "巨大結腸",
    "melanosis_coli": "大腸メラノーシス",
    "metastatic_tumor": "転移性腫瘍",
    "mid-body": "体中部",
    "middle": "中部",
    "minor_bleeding": "少量出血",
    "mixed": "混合痔核",
    "mixed_hemorrhoid": "混合痔核",
    "morphology": "肉眼型",
    "mucosa_prolapse": "粘膜脱症候群",
    "mucus_plaque": "粘液プラーク",
    "multiple": "多発",
    "nearly_complete_obstruction": "亜完全閉塞",
    "necrosis": "壊死",
    "needle_knife": "ニードルナイフ",
    "negative": "陰性",
    // "net": "device 是 ネット / Finding是NET",
    "net": "NET",
    "nipple_sign": "ニップルサイン",
    "nodularity": "結節性変化",
    "non-specific_colitis": "非特異性腸炎",
    "number": "個數",
    "object": "除去物",
    "obstruction": "閉塞",
    "occult_bleeding": "潜血",
    "operation_scar": "手術瘢痕",
    "orientation": "方向",
    "other": "その他",
    "others": "その他",
    "overall": "全て",
    "overlying_membrane": "被覆粘膜",
    "papilla": "乳頭",
    "paris": "パリ分類",
    "partial_obstruction": "部分閉塞",
    "patho": "病理",
    "pedunculated": "有茎性",
    "pentapod_grasping_forceps": "五脚把持鉗子",
    "perforation": "穿孔",
    "petechia": "点状出血",
    "peutz-jeghers_syndrome": "Peutz-Jeghers 症候群",
    "pieces_of_tissue": "組織數",
    "pillow_sign": "クッションサイン",
    "pink-color_sign": "ピンクカラーサイン",
    "polyp": "ポリープ",
    "polypectomy": "ポリペクトミー",
    "polypoid_tumor": "隆起性腫瘍",
    "portal_hypertensive_gastropathy": "門脈圧亢進性胃症",
    "positive": "陽性",
    "post_endoscopy_treatment_scar": "内視鏡治療後瘢痕",
    "post_operation": "手術後",
    "post-treatment_residual_neoplasm": "治療後残存腫瘍",
    "prague_c": "プラハ C",
    "prague_m": "プラハ M",
    "proctitis": "直腸炎",
    "proximal": "近位",
    "pseudomembranous_colitis": "偽膜性大腸炎",
    "pw": "後壁",
    "radiation_colitis": "放射線性腸炎",
    "raised_erosion": "隆起性びらん",
    "red_color_sign": "発赤所見",
    "recent_bleeding": "最近の出血",
    "rectal_varices": "直腸静脈瘤",
    "rectum": "直腸",
    "red_whale_marking": "ミミズ腫れ様所見",
    "reflux_esophagitis": "逆流性食道炎",
    "removal_forceps": "除去鉗子",
    "removed": "除去",
    "right_hemicolectomy": "右半結腸切除術",
    "r/o": "鑑別疾患",
    "rs_junction": "RS接合部",
    "rubber_band": "バンド",
    "rugal_atrophy": "ひだ萎縮",
    "rugal_hypertrophy": "ひだ腫大",
    "s/p_endolooping": "結紮術後",
    "s/p_hemoclipping": "ヘモクリップ後",
    "s/p_partial_colectomy": "部分結腸切除後",
    "s/p_stenting": "ステント留置",
    "s/p_tattooing": "点墨",
    "saline": "生理食塩水",
    "sb_tube": "SBチューブ",
    "scar": "瘢痕",
    "ulcer_scar": "瘢痕期",
    "scattered": "散在",
    "sclerotherapy": "硬化療法",
    "sda": "上十二指腸角",
    "sessile": "無茎性",
    "sessile_serrated_adenoma": "無茎性鋸歯状腺腫",
    "several": "複数",
    "shallow": "浅い",
    "sigmoid_colon": "S状結腸",
    "sign": "サイン",
    "silver_sign": "シルバーサイン",
    "situs_inversus": "内臓逆位",
    "size": "サイズ",
    "skip-lesion": "非連続病変",
    "skiplesion": "非連続病変",
    "small": "小さい",
    "snare": "スネア",
    "soft": "軟",
    "sessile_or_pedunculated": "形狀",
    "s_pattern": "Surface pattern",
    "specimen_label": "検体ラベル",
    "splenic_flexure": "脾彎曲",
    "spotted": "斑状",
    "stich": "縫合",
    "stitches": "縫合",
    "stretta": "ストレッタ",
    "subepithelial_tumor": "上皮下腫瘍",
    "subtotal_gastrectomy": "胃亜全摘術",
    "sucralfate_gel": "スクラルファートゲル",
    "superficial_gastritis": "表層性胃炎",
    "suture_granuloma": "吻合部肉芽腫",
    "swelling_mucosa": "粘膜腫大",
    "take_note_of": "指定",
    "tarry_stool": "タール便",
    "tb_colitis": "結核性腸炎",
    "tb_related_lesion": "結核関連病変",
    "terminal_ileum": "回腸末端",
    "the_most_significant": "最重要所見",
    "tiny": "微小な",
    "tooth": "歯状鉗子",
    "total_gastrectomy": "胃全摘術",
    "traditional_serrated_adenoma": "鋸歯状腺腫",
    "transverse_colon": "横行結腸",
    "triangle_knife": "トライアングルナイフ",
    "tubular_adenoma": "管状腺腫",
    "tubulovillous_adenoma": "管状絨毛腺腫",
    "tumor": "腫瘍",
    "ulcer": "潰瘍",
    "ulcerative": "潰瘍あり",
    "ulcerative_colitis": "潰瘍性大腸炎",
    "ulcer_stage": "潰瘍ステージ",
    "unknown_bleeder": "出血源不明",
    "upper": "上部",
    "upper_gi": "上部消化管",
    "upper_gi_bleeding": "上部消化管出血",
    "v_pattern": "Vascular pattern",
    "villous_adenoma": "絨毛腺腫",
    "visibility_of_vascular_pattern": "血管パターンの可視性",
    "xanthoma": "黄色腫",
    "inflammatory_adenoma": "",
    "consent_not_obtained_from_the_patient": "",
    "difficulty_in_management_refer_for_surgery": "",
    "difficulty_in_management_will_resect_at_another_sessio_of_colonoscopy": "",
    "difficulty_in_management_refer_to_other_hospital": "",
    "nil": "",
    "unexpected_trouble_during_management_cardiopulmonary_event_other_complicaiotn_mechanical_etc": "",
    "use_of_anti-platelet_or_anti-coagulant": "",
    "yellow": "黄色調",
  },
  const_words: {
    perforation: "Perforation",
    nil: "Nil",
    significant_bleeding: "著明な出血",
    cardiopulmonary_complication: "心肺合併症",
    pylorus: "pylorus",
    antrum: "antrum",
    lowbody: "low-body",
    terminalileum: "Terminal ileum",
    cecum: "Cecum",
    ascendingcolon: "Ascending colon",
    hepaticflexure: "Hepatic flexure",
    transversecolon: "Transverse colon",
    splenicflexure: "Splenic flexure",
    descendingcolon: "Descending colon",
    sigmoidcolon: "Sigmoid colon",
    rectum: "Rectum",
    anastomosis: "Anastomosis",
    anus: "Anus",
    ileocecalvalve: "Ileocecal valve",
    appendixorifice: "Appendix orifice",
    proximalascendingcolon: "Proximal Ascending Colon",
    middleascendingcolon: "Middle Ascending Colon",
    distalascendingcolon: "Distal Ascending Colon",
    proximaltransversecolon: "Proximal Transverse colon",
    middletransversecolon: "Middle Transverse colon",
    distaltransversecolon: "Distal Transverse colon",
    proximaldescendingcolon: "Proximal Descending Colon",
    middledescendingcolon: "Middle Descending Colon",
    distaldescendingcolon: "Distal Descending Colon",
    proximalsigmoidcolon: "Proximal Sigmoid Colon",
    middlesigmoidcolon: "Middle Sigmoid Colon",
    distalsigmoidcolon: "Distal Sigmoid Colon",
    rsjunction: "RS junction",
    upperrectum: "Upper Rectum",
    midrectum: "Middle Rectum",
    lowerrectum: "Lower Rectum",
    rsjunction: "RS junction",
    analretroflex: "Anal retroflex",
    allsegments: "All segments of colon",
  },
  examination_detail: {
    exam_type: "検査種別",
    exam_record: "検査No.",
    name: "名前",
    med_record: "患者ID",
    delete_finding_start: "検出結果",
    delete_finding_end: "を削除します。元の検出結果番号が置き換えられます。削除してもよろしいですか?",
    delete_finding: "消去",
    orientation: "方向",
    location: "部位",
    from_incisor: "incisorからの距離",
    delete_image_confirm: "この画像を削除してもよろしいですか?",
    delete_image_confirm_yes: "はい",
    delete_image_confirm_no: "いいえ",
  },
  /**
   * 「適應症」改為「検査適応」
．「1 國健局糞便潛血檢查陽性」改為「便潜血陽性」
．「2 自費健康檢查」改為「人間ドック」
．「9a 大腸癌家族史」改為「大腸癌家族歴」
．「9b 瘜肉切除後追蹤」改為「ポリープ切除後フォロー」
．「9c 大腸癌術後追蹤」改為「大腸癌術後フォロー」
．9d: ?? (Would you please explain in English?)
．「9e 瘜肉或腫瘤切除」改為「内視鏡治療」
．「9f 発炎性腸道疾病追蹤」改為「炎症性腸疾患フォロー」
．「9g 術前評估」改為「術前評価」
   */
  indication:{
    title: "検査適応",
    item1: "便潜血陽性",
    item2: "人間ドック",
    item9a: "大腸癌家族歴",
    item9b: "ポリープ切除後フォロー",
    item9c: "大腸癌術後フォロー",
    item9e: "内視鏡治療",
    item9f: "炎症性腸疾患フォロー",
    item9g: "術前評価",
  }
}
